<template lang="pug">
f7-page#app-link
  navbar(title="スポともダンスアプリ")

  background

</template>

<style lang="scss" scoped>
.page-content {
  padding-top: 60px !important;
  position: relative;
  overflow: hidden;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'

export default {
  mixins: [PageTitle],
  title: 'スポともダンスアプリ',
  methods: {
    async redirectByOs() {
      let ua = navigator.userAgent
      if (
        ua.indexOf('iPhone') != -1 ||
        ua.indexOf('iPad') != -1 ||
        ua.indexOf('iPod') != -1
      ) {
        location.href =
          'https://apps.apple.com/jp/app/%E3%83%80%E3%83%B3%E3%82%B9%E7%B7%B4%E7%BF%92-%E3%83%9E%E3%83%B3%E3%83%84%E3%83%BC%E3%83%9E%E3%83%B3%E3%83%AC%E3%83%83%E3%82%B9%E3%83%B3%E3%81%8C%E3%81%A7%E3%81%8D%E3%82%8B%E3%82%B9%E3%83%9D%E3%81%A8%E3%82%82%E3%83%80%E3%83%B3%E3%82%B9/id1433856004'
      } else if (ua.indexOf('Android') != -1) {
        location.href =
          'https://play.google.com/store/apps/details?id=com.dank_1.spotomo_dance'
      } else {
        location.href = '/'
      }
    },
  },
  mounted() {
    this.redirectByOs()
  },
}
</script>
